import { UserRole } from '@/services/ws-permissions/src/main/resources/rest-api';
import { useAuth, useIdentityRoles } from '@/js/libs/use-auth';

import { DEV_MODE } from 'src/constants.ts';

export const useNavigationComponentsVisibilityChecks = () => {
  const { POSTNETZ_BRANCH_USER, READ_ONLY_POSTNETZ_BRANCH_USER, POSTADMANAGER, YALEO_SELF_BOOKING, ADMIN, SWITCH_COMPANY_VIEW } =
    useIdentityRoles();
  const { impersonatedUser, loggedUser, selectedCompany } = useAuth();
  // One selection at a time: the company switch hides while a user is impersonated, the user switch while a company is
  // selected. Impersonation is a testing aid of the dev stand, offered to the logged admin.
  return {
    isGlobalSearchVisible: ADMIN || (!POSTNETZ_BRANCH_USER && !READ_ONLY_POSTNETZ_BRANCH_USER && !POSTADMANAGER && !YALEO_SELF_BOOKING),
    isCompanySwitchVisible: !!SWITCH_COMPANY_VIEW && !impersonatedUser,
    isUserSwitchVisible: DEV_MODE && loggedUser?.userRole === UserRole.ADMIN && !selectedCompany,
  };
};
